(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-mybets-wager/assets/react/components/finished-wager-summary.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-mybets-wager/assets/react/components/finished-wager-summary.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const wagerHelper = svs.lyckoplatsen.shared_mybets_wager.utils.wagerHelper;
const Icon = svs.ui.ReactIcon;
const formatCurrency = svs.utils.format.Currency;
const FormatTime = svs.utils.date.FormatTime;
const DRAWS = svs.lyckoplatsen.components.shared_constants.CONSTANTS.DRAWS;
const ProlongButton = svs.lyckoplatsen.components.shared_mybets_wager.react.components.ProlongButton;
const unProlongedWagersAtom = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms.unProlongedWagersAtom;
const ProlongBanner = () => React.createElement("div", {
  className: "bg-white u-flex padding-v"
}, React.createElement("div", {
  className: "f-content margin-left-1 margin-right"
}, "Du har nyligen f\xF6rl\xE4ngt detta spel"), React.createElement("div", {
  className: "icon-circle-wrapper bg-green u-flex u-flex-justify-content-center u-flex-align-items-center"
}, React.createElement(Icon, {
  color: "icon-inverted",
  icon: "checkmark",
  size: "100"
})));
const FinishedWagerSummary = _ref => {
  var _currentWin$amount;
  let wager = _ref.wager;
  const selectedResultAtom = svs.lyckoplatsen.components.shared_result.jotai.atoms.selectedResultAtom;
  const unProlongedWagers = useAtomValue(unProlongedWagersAtom);
  const result = useAtomValue(selectedResultAtom);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isRecentlyProlonged = _useState2[0],
    setIsRecentlyProlonged = _useState2[1];
  const geoBoardData = wager.wager.bets[0].geoBoardData;
  const charity = wager.wagerCharity;
  const totalDrawCount = wager.totalDrawCount,
    addonTotalDrawCount = wager.addonTotalDrawCount,
    channel = wager.properties.channel,
    regWagerTime = wager.regWagerTime,
    betAmount = wager.betAmount,
    completedDraws = wager.completedDraws,
    wagerId = wager.wagerId,
    isSubscription = wager.isSubscription;
  const _geoBoardData$geoLoc = geoBoardData.geoLoc,
    latitude = _geoBoardData$geoLoc.latitude,
    longitude = _geoBoardData$geoLoc.longitude;
  const locationName = geoBoardData.geoLocName;
  const allTotalDrawCount = totalDrawCount + addonTotalDrawCount;
  const distanceFromTopWin = wagerHelper.getDistanceFromWin(wager, result, false);
  const distanceFromWin = wagerHelper.getDistanceFromWin(wager, result, true);
  const currentWin = wagerHelper.getWin(wager, result);
  const completedDrawTime = wagerHelper.getCompletedDrawTime(wager, result);
  const isWin = Boolean(currentWin);
  const isDiv1 = isWin && currentWin.winDiv === 0;
  const drawsCount = completedDraws.filter(draw => new Date(draw.time) < new Date(result.regCloseTime)).length + 1;
  const isProlongable = wagerHelper.getIsProlongable(wager);
  const Bold = _ref2 => {
    let children = _ref2.children;
    return React.createElement("span", {
      className: "f-bold"
    }, children);
  };
  const isCustomerSupport = svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE);
  const totalWinAmount = wager.wins.reduce((acc, win) => acc + parseInt(win.amount, 10), 0);
  useEffect(() => {
    (async () => {
      const _await$svs$tur$prolon = await svs.tur.prolongStorage.get({
          wagerId,
          productId: 'lyckoplatsen'
        }),
        timestamp = _await$svs$tur$prolon.timestamp;
      setIsRecentlyProlonged(Boolean(timestamp));
    })();
  }, [wagerId, unProlongedWagers]);
  return React.createElement("div", {
    className: "wager-summary",
    "data-wager-id": wager.wagerId
  }, React.createElement("div", {
    className: "wager-summary-content"
  }, isRecentlyProlonged && React.createElement(ProlongBanner, null), React.createElement("div", {
    className: "wager-summary-header"
  }, locationName), React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Betalt:"), " ", React.createElement("span", null, FormatTime("d/M', kl. 'HH:mm", regWagerTime)))), React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Insats:"), " ", React.createElement("span", null, formatCurrency(betAmount), " kr"))), (totalDrawCount > DRAWS.DRAWS_PER_WEEK || isSubscription) && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Insats per vecka:"), " ", React.createElement("span", null, isSubscription ? formatCurrency(parseInt(betAmount, 10)) : formatCurrency(parseInt(betAmount, 10) / DRAWS.NUMBER_OF_WEEKS), " kr"))), latitude && longitude && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Koordinater:"), " ", latitude, '\u00b0', "N - ", longitude, '\u00b0', "E")), !isDiv1 && distanceFromTopWin && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Avst\xE5nd till toppvinst:"), " ", distanceFromTopWin)), !isWin && distanceFromWin && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Avst\xE5nd till n\xE4rmaste vinst:"), " ", distanceFromWin)), charity && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Bidrar till:"), " ", charity.name)), !isSubscription && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell border-right"
  }, React.createElement(Bold, null, "Dragning:"), " ", React.createElement("span", null, drawsCount, " av ", allTotalDrawCount))), React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Avgjordes:"), " ", React.createElement("span", null, svs.utils.date.ShortDateAndTime(completedDrawTime, false, true)))), React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell bg-grey-200"
  }, React.createElement(Bold, null, "Spelat via:"), " ", React.createElement("span", {
    className: "f-capitalize"
  }, isSubscription ? 'Prenumeration' : channel))), wager.wins && wager.wins.length > 0 && React.createElement("div", {
    className: "wager-summary-row"
  }, !(currentWin && wager.wins.length === 1) && React.createElement("div", {
    className: "wager-summary-cell border-right"
  }, React.createElement(Bold, null, "Total vinst:"), " ", formatCurrency(totalWinAmount), " kr"), React.createElement("div", {
    className: "wager-summary-cell ".concat(currentWin && wager.wins.length === 1 && 'u-flex-justify-content-center')
  }, React.createElement(Bold, null, "Vinst:"), " ", formatCurrency((_currentWin$amount = currentWin === null || currentWin === void 0 ? void 0 : currentWin.amount) !== null && _currentWin$amount !== void 0 ? _currentWin$amount : 0), " kr")), currentWin && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell border-right"
  }, React.createElement(Bold, null, "Utbetalning:"), currentWin.payoutTarget), React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Utbetalningsdatum:"), " ", FormatTime('d/M', currentWin.payoutTime))), isCustomerSupport && React.createElement("div", {
    className: "wager-summary-row"
  }, React.createElement("div", {
    className: "wager-summary-cell"
  }, React.createElement(Bold, null, "Wager ID:"), " ", wagerId))), isProlongable && React.createElement(ProlongButton, {
    wager: wager
  }));
};
setGlobal('svs.lyckoplatsen.components.shared_mybets_wager.react.components', {
  FinishedWagerSummary
});

 })(window);